import { render, staticRenderFns } from "./CompanyQualification.vue?vue&type=template&id=a835b6d8&scoped=true"
import script from "./CompanyQualification.vue?vue&type=script&lang=js"
export * from "./CompanyQualification.vue?vue&type=script&lang=js"
import style0 from "./CompanyQualification.vue?vue&type=style&index=0&id=a835b6d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a835b6d8",
  null
  
)

export default component.exports